<template>
  <!-- Dashboard Content
	================================================== -->
  <div class="dashboard-content-container" data-simplebar>
    <div class="dashboard-content-inner">
      <!-- Dashboard Headline -->
      <div class="dashboard-headline">
        <h3>Payments</h3>

        <!-- Breadcrumbs -->
        <nav id="breadcrumbs" class="dark">
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">Dashboard</a></li>
            <li>Payments</li>
          </ul>
        </nav>
      </div>

      <!-- Row -->
      <div class="row">
        <!-- Dashboard Box -->
        <div class="col-xl-12">
          <p>Payments here</p>
        </div>
      </div>

      <app-footer></app-footer>
    </div>
  </div>
  <!-- Dashboard Content / End -->
</template>

<script>
  /* eslint-disable no-console */
  import { 
    ALL_MY_PAYMENTS, 
    VERIFY_PROJECT_PAYMENT, 
    MY_SUCCESSFUL_PAYMENTS
  } from '../../../core/config/endpoints/project-payment';
  import { getCall } from '../../../core/services/http.service';
  import { AppFooter } from '../../partials/user-dashboard';

  export default {
    name: 'Payments',
    components: {
      AppFooter,
    },
    data() {
      return {};
    },

    methods: {
      verifyPayment({ project_id: projectId, user_id: userId }) {
        projectId, userId;
        this.$store.commit('setIsLoaded', true);
        getCall(VERIFY_PROJECT_PAYMENT.VERIFY({ trxref: '', reference: '' }))
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            this.$toast.error(`${error.response.data.message}`);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },

      getAllMyPayments({ project_id: projectId, user_id: userId }) {
        projectId, userId;
        this.$store.commit('setIsLoaded', true);
        getCall(ALL_MY_PAYMENTS)
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            this.$toast.error(`${error.response.data.message}`);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },

      getAllMySuccessfulPayments(projectId, userId) {
        this.$store.commit('setIsLoaded', true);
        getCall(MY_SUCCESSFUL_PAYMENTS, {
          project_id: projectId,
          user_id: userId,
        })
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            this.$toast.error(`${error.response.data.message}`);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },
    },
  };
</script>

<style></style>
